<template>
  <div>
    <template v-if="hasVideo">
      <iframe
        v-if="isYouTube"
        class="tw-h-96 tw-w-full tw-rounded-t-xl"
        :src="`https://www.youtube.com/embed/${video.id}`"
        allowfullscreen
      />
      <div
        v-else
        class="tw-border-b tw-border-neutral-300 tw-bg-gradient-to-r tw-from-success-50 tw-via-white tw-to-white tw-px-6 tw-py-4"
      >
        <BaseButton color="outline-green" :href="video.url" target="_blank">
          <TriangleRightIcon class="tw-mr-2 tw-h-4 tw-w-4" />
          Play video intro
        </BaseButton>
      </div>
    </template>
    <div
      v-else-if="isEditModeEnabled"
      class="tw-flex tw-h-32 tw-items-center tw-justify-center tw-rounded-t-xl tw-bg-neutral-200"
    >
      <TriangleRightIcon class="tw-h-8 tw-w-8 tw-text-neutral-400" />
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/shared/components/BaseButton.vue'
import TriangleRightIcon from '@/assets/images/icons/triangle-right.svg'
import { computed } from 'vue'
import { useEditProfileModeInjector } from '@/shared/composables/edit-profile-mode/useEditProfileModeInjector.js'

const props = defineProps({
  video: {
    type: Object,
    required: true,
  },
})

const { isEditModeEnabled } = useEditProfileModeInjector()

const isYouTube = computed(() => props.video.host === 'youtube')
const hasVideo = computed(() => Boolean(props.video?.url))
</script>
